import { getEnvironment } from "./getEnvironment.mjs";
export function isWebView() {
  switch (getEnvironment()) {
    case 'Android':
    case 'Cupertino':
      {
        return true;
      }

    default:
      {
        return false;
      }
  }
}